// Function to fetch the data
async function fetchData(url) {
  try {
    const response = await fetch(url);


    const data = await response.text();

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

// Function to replace content in an element with a specific ID
function replaceContent(elementId, newData) {
  const element = document.getElementById(elementId);
  let parser = new DOMParser();
  let parsedData = parser.parseFromString(newData, "text/html");
  const renderData = parsedData.getElementById(elementId);

  if (element && renderData) {
    element.replaceWith(renderData);

    // Sort cart items after content replacement on cart page
    if (elementId === 'cart_page') {
      setTimeout(() => {
        const cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.sortCartItems === 'function') {
          cartItems.sortCartItems();
        }
      }, 0);
    }
  } else {
    console.error("Element with ID " + elementId + " not found.");
  }
}
function disableDeleteButton() {
  let items = document.querySelectorAll(".cart-item");
  for (let i = 0; i < items.length; i++) {
    let deleteButton = items[i].querySelector(".discounts__discount p");
    if (deleteButton) {
      if (deleteButton.innerHTML == "Free BOM -") {
        if (items[i].querySelector("cart-remove-button")) {
          items[i]
            .querySelector("cart-remove-button")
            .classList.add("disabled");
          items[i]
            .querySelector("cart-remove-button")
            .setAttribute("disabled", true);
        }
        if (items[i].querySelector(".cart-remove-button")) {
          items[i]
            .querySelector(".cart-remove-button")
            .classList.add("disabled");
          items[i]
            .querySelector(".cart-remove-button")
            .setAttribute("disabled", true);
        }
      }
    }
  }
}
disableDeleteButton();
function removeFreeProduct() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const productHandles = cart.items.map((item) => ({
        handle: item.handle,
        lineItemKey: item.key,
      }));
      const productPromises = productHandles.map((handleObj) =>
        fetch(`/products/${handleObj.handle}.js`).then((response) =>
          response.json().then((product) => ({
            ...product,
            lineItemKey: handleObj.lineItemKey,
          }))
        )
      );
      Promise.all(productPromises).then((products) => {
        const productTags = products.map((product) => ({
          id: product.id,
          tags: product.tags,
          handle: product.handle,
          quantity: cart.items.find((item) => item.handle === product.handle)
            .quantity,
          lineItemKey: product.lineItemKey,
        }));
        for (let i = 0; i < productTags.length; i++) {
          let item = document.querySelector(
            `.${CSS.escape(productTags[i].lineItemKey)}`
          );
          if (
            item.querySelector(".quantity__input").dataset
              .variantInventoryQty == 0
          ) {
            removeSampleProduct(productTags[i], productTags[i].quantity);
          }
        }
      });
    });
}
function removeAllSampleProducts(sampleProducts) {
  // Create an updates object to set quantities to 0 for all sample products
  const updates = {};
  sampleProducts.forEach((product) => {
    updates[product.lineItemKey] = 0;
  });

  // Make the request to cart/update.js to remove all sample products at once
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {

      location.reload(); // Optionally reload the page to reflect the changes
    })
    .catch((error) => {
      console.error("There was a problem with the fetch operation:", error);
    });
}

function removeSampleProduct(sampleProduct, quantityToRemove) {
  const itemKey = sampleProduct.lineItemKey;
  const newQuantity = sampleProduct.quantity - quantityToRemove;

  // Ensure new quantity is not below zero
  const itemQuantity = newQuantity >= 0 ? newQuantity : 0;

  const data = JSON.stringify({
    id: itemKey,
    quantity: itemQuantity,
  });

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: data,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {

      location.reload();
    })
    .catch((error) => {
      console.error("There was a problem with the fetch operation:", error);
    });
}
function disableDeleteButton() {
  let items = document.querySelectorAll(".cart-item");
  for (let i = 0; i < items.length; i++) {
    let deleteButton = items[i].querySelector(".discounts__discount p");
    if (deleteButton) {
      if (deleteButton.innerHTML == "Free BOM -") {
        if (items[i].querySelector("cart-remove-button")) {
          items[i]
            .querySelector("cart-remove-button")
            .classList.add("disabled");
          items[i]
            .querySelector("cart-remove-button")
            .setAttribute("disabled", true);
        }
        if (items[i].querySelector(".cart-remove-button")) {
          items[i]
            .querySelector(".cart-remove-button")
            .classList.add("disabled");
          items[i]
            .querySelector(".cart-remove-button")
            .setAttribute("disabled", true);
        }
      }
    }
  }
}
disableDeleteButton();
function removeFreeProduct() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const productHandles = cart.items.map((item) => ({
        handle: item.handle,
        lineItemKey: item.key,
      }));
      const productPromises = productHandles.map((handleObj) =>
        fetch(`/products/${handleObj.handle}.js`).then((response) =>
          response.json().then((product) => ({
            ...product,
            lineItemKey: handleObj.lineItemKey,
          }))
        )
      );
      Promise.all(productPromises).then((products) => {
        const productTags = products.map((product) => ({
          id: product.id,
          tags: product.tags,
          handle: product.handle,
          quantity: cart.items.find((item) => item.handle === product.handle)
            .quantity,
          lineItemKey: product.lineItemKey,
        }));
        for (let i = 0; i < productTags.length; i++) {
          let item = document.querySelector(
            `.${CSS.escape(productTags[i].lineItemKey)}`
          );
          if (
            item.querySelector(".quantity__input").dataset
              .variantInventoryQty == 0
          ) {
            removeSampleProduct(productTags[i], productTags[i].quantity);
          }
        }
      });
    });
}
// OLD sampleProduct function - DISABLED
// Now using oj-compliementary.js for sample management 
function sampleProduct() {
  if (window.OjarFreeSamples && window.OjarFreeSamples.enforceSampleLimit) {
    window.OjarFreeSamples.enforceSampleLimit();
  }
}
sampleProduct();
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  /**
   * Sort cart items to show products with 'enable-complimentary' tag first
   */
  sortCartItems() {
    const cartTable = this.querySelector('.cart-items tbody');
    if (!cartTable) return;

    const rows = Array.from(cartTable.querySelectorAll('tr.cart-item'));
    if (rows.length === 0) return;

    // Sort: enable-complimentary products first, then others
    rows.sort((a, b) => {
      const aHasComplimentary = a.dataset.tags && a.dataset.tags.includes('enable-complimentary');
      const bHasComplimentary = b.dataset.tags && b.dataset.tags.includes('enable-complimentary');

      if (aHasComplimentary && !bHasComplimentary) return -1;
      if (!aHasComplimentary && bHasComplimentary) return 1;
      return 0;
    });

    // Re-append rows in sorted order
    rows.forEach(row => cartTable.appendChild(row));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    // Sort items when component is connected
    setTimeout(() => {
      this.sortCartItems();
    }, 0);

    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {


          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {


          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;

          // Sort items after updating cart page
          if (typeof this.sortCartItems === 'function') {
            setTimeout(() => {
              this.sortCartItems();
            }, 0);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }



        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .then(function (result) {
        const urlToFetch = window.location.pathname;

        fetchData(urlToFetch).then((fetchedData) => {
          // Replace the content of the element with the fetched data
          // Replace the first argument with the ID you want to replace
          replaceContent('cart_drawer', fetchedData);
          replaceContent('cart_page', fetchedData);
          // Dispatch custom event to trigger cart sorting
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
        sampleProduct();
        removeFreeProduct();
        disableDeleteButton();
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
